export const state = {
    grupoProduto: {},
    gruposProduto: [],
    modalCadastroGrupoProduto: false,
    modalExcluirGrupoProduto: false,
}

export default {}